export class CapitalBarGraphData {
	static currentYear = new Date().getFullYear();
	static currentDate = new Date();
	static months = {
		jan: `01-01-2022`,
		feb: `02-02-2022`,
		mar: `03-03-2022`,
		apr: `04-04-2022`,
		may: `05-05-2022`,
		jun: `06-06-2022`,
		jul: `07-07-2022`,
		aug: `08-08-2022`,
		sep: `09-09-2022`,
		oct: `10-10-2022`,
		nov: `11-11-2022`,
		dec: `12-12-2022`,
	};
	static graphData = {
		series: [
			{
				name: 'Repayment',
				data: [
					{ x: CapitalBarGraphData.months.jan, y: 9416 },
					{ x: CapitalBarGraphData.months.feb, y: 9416 },
					{ x: CapitalBarGraphData.months.mar, y: 9416 },
					{ x: CapitalBarGraphData.months.apr, y: 9416 },
					{ x: CapitalBarGraphData.months.may, y: 9416 },
					{ x: CapitalBarGraphData.months.jun, y: 9416 },
					{ x: CapitalBarGraphData.months.jul, y: 9416 },
					{ x: CapitalBarGraphData.months.aug, y: 9416 },
					{ x: CapitalBarGraphData.months.sep, y: 9416 },
					{ x: CapitalBarGraphData.months.oct, y: 9416 },
					{ x: CapitalBarGraphData.months.nov, y: 9416 },
					{ x: CapitalBarGraphData.months.dec, y: 9416 },
				],
			},
		],
	};

	static sortByCurrentDate(monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']) {
		const now = new Date();
		const currentMonth = now.getMonth();
		const currentYear = now.getFullYear();
		const seriesData = this.graphData.series[0].data;

		return Array.from({ length: 12 }, (_, i) => {
			const offset = i + 1;
			const monthIndex = (currentMonth + offset) % 12;
			const year = currentYear + Math.floor((currentMonth + offset) / 12);
			return {
				x: [monthNames[monthIndex], String(year)],
				y: seriesData[monthIndex].y,
			};
		});
	}
}
